<ng-container *transloco="let t; prefix: 'organizations.detailPage.riskAnalysisDeliveryTab'">
  @if (loading()) {
    <div class="b-loader">
      <aml-loader [isLoading]="true" />
    </div>
  }

  @if (periods().length > 0) {
    <nz-collapse nzAccordion class="b-period-panel">
      @for (tracker of periods(); track tracker.id) {
        <nz-collapse-panel
          [nzHeader]="panelHeader"
          [nzActive]="deliveryTrackerDetailFacade.isTrackerIdExpanded(tracker.id)"
          (nzActiveChange)="onPeriodExpandChange(tracker.id, $event)"
        >
          <ng-template #panelHeader>
            <span class="b-period-panel__header">
              @if (isCurrentPeriod(tracker)) {
                {{ t('sections.current') }}
              } @else {
                {{ getPeriodLabel(tracker) }}
              }
            </span>
            @let presence = getReminderTrackerPresence(tracker.id);
            @if (presence) {
              <aad-reminder-tracker-presence-badge
                [reminderTrackerStatus]="presence.reminderTrackerStatus"
                [deliveryTrackerStatus]="tracker.status"
                [contractInactive]="isContractInactive()"
                [reminderTrackerCreatedAt]="presence.reminderTrackerCreatedAt"
                [reminderTrackerUpdatedAt]="presence.reminderTrackerUpdatedAt"
                [reminderTrackerNextReminderAt]="presence.reminderTrackerNextReminderAt"
                [reminderTrackerStatusChangedAt]="presence.reminderTrackerStatusChangedAt"
                [hasActiveNotifiableUser]="hasActiveNotifiableUser()"
              />
            }
          </ng-template>

          @if (deliveryTrackerDetailFacade.isTrackerIdExpanded(tracker.id)) {
            <aad-delivery-tracker-email-list [deliveryTracker]="tracker" />
          }
        </nz-collapse-panel>
      }
    </nz-collapse>
  } @else if (!loading()) {
    <p class="text-center">{{ t('noData') }}</p>
  }
</ng-container>
